import { makeAutoObservable } from 'mobx'
import { RequestCancelAxios } from 'shared/api/lib'
import { logger } from 'shared/lib'
import { UsersApi } from 'entities/Users'
import { QUIET_HOURS_BANNER_PERMANENT_HIDE_COUNT } from 'entities/QuietHours/lib/constants'

export class QuietHoursClosureStore {
  private _closureCounter = 0
  private _isLoading = false
  private _isLoaded = false
  private _cancelRequest = new RequestCancelAxios()

  constructor() {
    makeAutoObservable(this)
  }

  get shouldHideBanner(): boolean {
    return this._isLoaded && this._closureCounter >= QUIET_HOURS_BANNER_PERMANENT_HIDE_COUNT
  }

  loadClosureCounter = async () => {
    if (this._isLoading) return
    this.setLoading(true)

    try {
      this._cancelRequest.init()
      const { data } = await UsersApi.getQuietHoursUiSettings({
        cancelToken: this._cancelRequest.token,
      })
      const closeCounter = data?.data?.items?.close_counter
      this.setCounter(typeof closeCounter === 'number' ? closeCounter : 0)
      this.setLoaded(true)
    } catch (e) {
      logger.error(e)
      this.setCounter(0)
      this.setLoaded(true)
    } finally {
      this.setLoading(false)
    }
  }

  incrementClosureCounter = async () => {
    const newCount = this._closureCounter + 1
    this.setCounter(newCount)
    try {
      await UsersApi.updateQuietHoursUiSettings({
        source_type: 'quite-hours-items',
        items: { close_counter: newCount },
      })
    } catch (e) {
      logger.error(e)
      this.setCounter(Math.max(0, this._closureCounter - 1))
    }
  }

  setLoading = (status: boolean) => {
    this._isLoading = status
  }

  setLoaded = (status: boolean) => {
    this._isLoaded = status
  }

  setCounter = (counter: number) => {
    this._closureCounter = counter
  }
}
